export default function(ngModule) {
    ngModule.factory('ScannerType', function(BaseClass,$q, $http, $translate, ErrorRejector, generateRandomString, Ticket) {

        /**
         * Constructor function
         *
         * @param {Object} attributes Initial attributes for the model
         */
        function ScannerType(attributes) {
            _.assign(this,attributes);
        }
        ScannerType.modelName = 'ScannerType';

        BaseClass.apply(ScannerType);

        /**
         * Return a new scanner with sensible defaults
         *
         * @param {String?} name Name for the new scanner
         * @return {ScannerType} A new scanner
         */
        ScannerType.newDefault = function(name) {
            return ScannerType.new({
                username: generateRandomString(6),
                password: generateRandomString(4),
                expires_at: moment().add(1, 'year').endOf('day').format('YYYY-MM-DDTHH:mm:ssZ'),
                name: name || ''
            });
        };

        ScannerType.validates({
            name: {
                required: true,
                length: {
                    max: 255
                }
            },
            username: {
                required: true,
                length: {
                    min: 6,
                    max: 255
                }
            },
            password: {
                requiredIf: {
                    requiredIf: function(value, instance) {
                        return !instance.guid;
                    }
                },
                length: {
                    min: 4,
                    max: 255
                }
            },
            restricted: {
                format: {
                    boolean: true
                }
            },
            visibility: {
                numericality: true
            },
            scan_types: {
                numericality: true
            },
            expires_at: {
                required: true,
                regex: {
                    // ISO8601 YYYY-MM-DDTHH:mm:ssZ
                    regex: /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}[\+\-]\d{2}:\d{2}$/
                }
            },
            tickets: {
                shouldHaveTickets: {
                    // Yes tickets also check for products for now... Once the scanners actually are able to scan tickets, this can be changed...
                    validator: function(value, instance, field) {
                        return (!_.isNil(instance.products) && instance.products.length > 0) || (!_.isNil(instance.tickets) && instance.tickets.length > 0)
                    },
                    message: 'models.scanner_type.notice.shouldHaveTickets'
                }
            },
            products: {
                required: true,
                shouldHaveProducts: {
                    validator: function(value, instance, field) {
                        return (!_.isNil(instance.products) && instance.products.length > 0) || (!_.isNil(instance.tickets) && instance.tickets.length > 0);
                    },
                    message: 'models.scanner_type.notice.shouldHaveProducts'
                }
            }
        });

        ScannerType.configureApi('/scanner/:guid', {
            queryAdmin: '/scanner/:status/:company',
            reinstate: '/scanner/:guid/reinstate'
        });
        ScannerType.belongsToMany(
            'Product',
            'products',
            '/scanner/:guid/product/^guid',
            [
                { type: 'query' },
                { type: 'attach' },
                { type: 'detach' }
            ]
        );

        ScannerType.belongsToMany(
            // This is a proxy relationship through products
            'Ticket',
            'tickets',
            '/scanner/:guid/ticket/^guid',
            [
                {
                    type: 'query',
                    fn: function(modelName, url, scanner) {
                        return scanner.$queryProduct()
                            .then(products => {
                                let ticketProducts = _.filter(
                                    products,
                                    p => p.isTicketProduct()
                                );
                                let promises = _.map(
                                    ticketProducts,
                                    product => Ticket.get({guid: product.description}).then(ticket => {
                                        // Event info is not added to proxy relations in the API
                                        // Do it here manually.
                                        if (!_.isUndefined(product.event_key)) {
                                            _.set(ticket, 'event_key', product.event_key);
                                        }

                                        if (!_.isUndefined(product.event_ids)) {
                                            _.set(ticket, 'event_ids', product.event_ids);
                                        }

                                        return ticket;
                                    })
                                );
                                return $q.all(promises);
                            });
                    }
                },
                {
                    type: 'attach',
                    fn: function(modelName, url, scanner, ticket) {
                        return ticket.$queryProduct()
                            .then(products => {
                                let ticketProduct = _.find(products, p => p.isTicketProduct(ticket.guid));

                                if(!ticketProduct){
                                    return ErrorRejector.handle('Could not attach Ticket');
                                }

                                return scanner.$attachProduct(ticketProduct);
                            });
                    }
                },
                {
                    type: 'detach',
                    fn: function(modelName, url, scanner, ticket) {
                        return ticket.$queryProduct()
                            .then(products => {
                                let ticketProduct = _.find(products, p => p.isTicketProduct(ticket.guid));

                                return scanner.$detachProduct(ticketProduct).then(model => {
                                    _.remove(model.products, {guid: ticketProduct.guid});

                                    return model;
                                });
                            });
                    }
                }
            ]
        );

        ScannerType.hasMany(
            'ScannerInstance',
            'instances',
            'scanner_type_guid',
            '/scanner/:guid/instance/^guid'
        );
        ScannerType.prototype.toString = function() { return this.name; };

        return ScannerType;
    });
}
